import type { Borders } from "exceljs";

export const allBorders = (): Partial<Borders> => {
  return {
    top: {
      style: "thin",
    },
    left: {
      style: "thin",
    },
    bottom: {
      style: "thin",
    },
    right: {
      style: "thin",
    },
  };
};
